import React from 'react';
import { cn } from '../../../utils/cn';
import { skeletonVariants } from './Skeleton.styles';
import type { SkeletonProps } from './Skeleton.types';

/**
 * Skeleton loading placeholder component
 *
 * Used to display a placeholder while content is loading.
 * Supports multiple variants and animations to match different content types.
 */
export const Skeleton = React.forwardRef<HTMLDivElement, SkeletonProps>(
  ({ className, variant = 'text', animation = 'pulse', width, height, style, ...props }, ref) => {
    const computedStyle: React.CSSProperties = {
      ...style,
      width: typeof width === 'number' ? `${width}px` : width,
      height: typeof height === 'number' ? `${height}px` : height,
    };

    return (
      <div
        ref={ref}
        className={cn(skeletonVariants({ variant, animation }), className)}
        style={computedStyle}
        aria-hidden="true"
        {...props}
      />
    );
  }
);

Skeleton.displayName = 'Skeleton';
